import Link from 'next/link';
import styled from 'styled-components';

import { GoatLogo } from 'shared/icons/GoatLogo';
import { variableFontRegular } from 'styles/theme/text';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';
import { useCheckoutContext } from 'checkout/providers/CheckoutContextProvider';
import { useStoreSelector } from 'store/hooks/storeHooks';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Header';

export const Header = () => {
  const isGuestCheckoutEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_GUEST_CHECKOUT);
  const { user } = useStoreSelector((state) => state.auth);
  const { isGuestCheckout } = useCheckoutContext();

  const isGuest = (isGuestCheckout || user?.isGuest) && isGuestCheckoutEnabled;

  return (
    <Header.Wrapper>
      <Header.Logo>
        <Link
          href="/"
          passHref
          aria-label={t(`${TP}.logoAltText`, 'GOAT logo')}
          data-qa="goat_logo"
        >
          <Header.GoatLogo width={38} height={9} />
        </Link>
      </Header.Logo>

      <Header.Extra data-qa="secure_header_text">
        {isGuest
          ? t(`${TP}.secureGuestCheckout`, 'Secure Guest Checkout')
          : t(`${TP}.secureCheckout`, 'Secure Checkout')}
      </Header.Extra>
    </Header.Wrapper>
  );
};

export default Header;

Header.Wrapper = styled.header`
  position: sticky;
  position: -webkit-sticky;
  top: 0;

  display: grid;
  grid-template-areas: 'logo extra';
  grid-template-columns: auto;
  grid-template-rows: min-content;

  background: ${({ theme }) => theme.navigation.backgroundColor};
  z-index: ${({ theme }) => theme.zIndex.nav};
  padding: 16px 16px 12px 16px;
  ${variableFontRegular({ size: '11.5px' })};

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    grid-template-areas: 'logo extra';
    grid-template-columns: 80px repeat(11, 1fr);
    padding: 12px 32px 0;
    ${variableFontRegular({ size: '11.5px', height: '14px' })};
    border-bottom: 1px solid ${({ theme }) => theme.navigation.borderColor};
  }
`;

Header.Logo = styled.div`
  grid-area: logo;
  height: 100%;
  text-align: left;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    padding: 12px 0;
    place-self: start;
  }
`;

Header.GoatLogo = styled(GoatLogo)`
  fill: ${({ theme }) => theme.navigation.textColor} !important;
`;

Header.Extra = styled.p`
  grid-area: extra;
  margin: 0;
  text-align: right;
  ${variableFontRegular({ size: '11px' })};
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    ${variableFontRegular({ size: '11px' })};
    padding: 12px 0;
    display: block;
    grid-column: end;
    place-self: end;
  }
`;
